/**
 * lib/portfolioFilter.js — Iter 53.1.
 *
 * Defensive search filter for the Portfolio page. Extracted so the
 * unit test in `__tests__/portfolioFilter.test.js` can cover the
 * crash regression independently of the React render.
 */
export function filterPortfolioProjects(projects, q) {
  if (!Array.isArray(projects)) return [];
  if (!q) return projects;
  const s = String(q).toLowerCase();
  const lc = (v) => (typeof v === "string" ? v.toLowerCase() : "");
  return projects.filter((p) => (
    lc(p?.name).includes(s)
    || lc(p?.number).includes(s)
    || lc(p?.project_number).includes(s)
    || lc(p?.client).includes(s)
    || lc(p?.location).includes(s)
    || lc(p?.status).includes(s)
  ));
}
